"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modeFromGoogle = exports.modeFromGoogleModeNonTransit = exports.modeFromGoogleTransitMode = void 0;
var index_1 = require("./index");
var modeFromGoogleTransitMode = function (googleMode) {
    switch ((googleMode || '').toUpperCase()) {
        case 'RAIL':
        case 'METRO_RAIL':
        case 'MONORAIL':
        case 'HEAVY_RAIL':
        case 'COMMUTER_TRAIN':
        case 'HIGH_SPEED_TRAIN':
        case 'LONG_DISTANCE_TRAIN':
            return index_1.ModeName.Train;
        case 'SUBWAY':
            return index_1.ModeName.Subway;
        case 'TRAM':
            return index_1.ModeName.Tramway;
        case 'BUS':
        case 'INTERCITY_BUS':
        case 'TROLLEYBUS':
            return index_1.ModeName.Bus;
        case 'FERRY':
            return index_1.ModeName.Ferry;
        case 'SHARE_TAXI':
        case 'CABLE_CAR':
        case 'GONDOLA_LIFT':
        case 'FUNICULAR':
        default:
            return index_1.ModeName.OtherTransit;
    }
};
exports.modeFromGoogleTransitMode = modeFromGoogleTransitMode;
// Doesn't support transit, we have another function for that
var modeFromGoogleModeNonTransit = function (googleMode) {
    switch ((googleMode || '').toUpperCase()) {
        case 'DRIVING':
            return index_1.ModeName.Drive;
        case 'WALKING':
            return index_1.ModeName.Walk;
        case 'BICYCLING':
            return index_1.ModeName.Bike;
        default:
            return;
    }
};
exports.modeFromGoogleModeNonTransit = modeFromGoogleModeNonTransit;
var modeFromGoogle = function (travelMode, transitVehicleType) {
    return (travelMode || '').toUpperCase() === 'TRANSIT'
        ? (0, exports.modeFromGoogleTransitMode)(transitVehicleType)
        : (0, exports.modeFromGoogleModeNonTransit)(travelMode);
};
exports.modeFromGoogle = modeFromGoogle;
//# sourceMappingURL=google.js.map